import { CREDENTIALS_STATUS } from 'app/constants';

const userInitialState = {
  userProfile: {
    firstName: '',
    middleName: '',
    lastName: '',
    mobile: '',
    email: '',
    alternatePhone: '',
    alternatePhoneExt: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
    isDiversityAffirmed: false,
    gender: '',
    otherGender: '',
    ethnicity: '',
    otherEthnicity: '',
    diverseGroup: '',
    otherDiverseGroup: '',
    ssn: '',
    taxIdType: '',
  },
};

const companyInitialState = {
  companyProfile: {
    name: '',
    phoneNumber: '',
    phoneNumberExt: '',
    alternatePhoneNumber: '',
    alternatePhoneNumberExt: '',
    faxNumber: '',
    faxExt: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
    businessType: '',
    yearFounded: '',
    responsibility: [],
    feeSchedule: '',
    companyOwner: '',
    keyContact: '',
    email: '',
    paymentEmail: '',
    confirmPaymentEmail: '',
    paymentMethod: '',
    crsId: '',
    isFirmIncorporated: null,
  },
};


const initialSate = () => ({
  applicationId: null,
  accessToken: null,
  isCallInprogress: false,
  isAuthenticated: false,
  status: null,
  constants: {
    APPRAISAL_METHODOLOGIES: [],
    BUSINESS: [],
    CLIENT: [],
    COMPANY_UPDATE_RESPONSIBILITY: [],
    DIVERSE_GROUP: [],
    DOCUMENT: [],
    ETHNICITY: [],
    GENDER: [],
    INSURANCE: [],
    LICENSE: [],
    MONTHLY_ORDERS: [],
    NUMBER_OF_CLIENTS: [],
    PROPERTY: [],
    PROGRAM_SERVICE_GROUPS: [],
    YEARS_APPRAISING: [],
    TAX_ID: [],
    SOFTWARE: [],
    SUPPORTED_FILE: [],
    STATUS: [
      {
        value: 'APPROVED',
        name: 'Approved',
        sortOrder: 7,
      },
      {
        value: 'DECLINED',
        name: 'Declined',
        sortOrder: 5,
      },
      {
        value: 'HOLD',
        name: 'Hold',
        sortOrder: 6,
      },
      {
        value: 'IN_PROGRESS',
        name: 'In Progress',
        sortOrder: 1,
      },
      {
        value: 'PENDING_REVIEW',
        name: 'Pending Review',
        sortOrder: 2,
      },
      {
        value: 'UNDER_REVIEW',
        name: 'Under Review',
        sortOrder: 3,
      },
      {
        value: 'VERIFICATION',
        name: 'Verification',
        sortOrder: 4,
      },
    ],
  },
  messageList: [],
  currentPage: null,
  ...userInitialState,
  ...companyInitialState,
  serviceGroupFees: {
    feeMap: {},
  },
  coverageList: [],
  regionCoverage: {
    zipCodes: [],
    baseArea: null,
    extendedArea: null,
    mlsCoverage: null,
    additionalAreas: null,
    typicalCompletion: {
      sunday: [],
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
    },
  },
  slaTargets: {
    tat: 0,
    srt: 10,
  },
  professionalInfo: {
    languages: '',
    appraisalMethodologies: [],
    hudFhaCertified: null,
    hudFhaNumber: null,
    typicalProperties: [],
    complexProperties: null,
    newConstruction: null,
    defaultAppraisals: null,
    multiFamilyAppraisals: null,
    clientMix: [],
    numOfClients: null,
    vaApproved: null,
    usdaExperience: null,
    pendingLitigation: null,
    lenderExcluded: null,
    disciplinaryAction: null,
    suspension: null,
    licenseInGoodStanding: null,
    licensureRefused: null,
    yearsAppraising: null,
    monthlyOrders: null,
    softwareType: null,
    supportedFileTypes: [],
  },
  eo: {
    insuranceType: null,
    policyNumber: null,
    nameOfInsured: null,
    carrierName: null,
    nameOfPersonCovered: null,
    expiryDate: null,
    perClaimLimit: null,
    aggregateLimit: null,
    claimFiled: null,
    fileByWhom: null,
    outcomeDescription: null,
    documentList: [],
  },
  credentials: {
    initialLicenseDate: null,
    documents: [],
  },
  credentialProgress: {
    credentialsStatus: CREDENTIALS_STATUS.INFO,
    section: {
      hasMaxLicenseCount: false,
      hasLicense: false,
      hasW9: false,
      hasProfilePhoto: false,
    },
  },
});

export default initialSate;

